import ContractTermEditor from './ContractTermEditor.yaml?component';
import UcContractTerms from './UcContractTerms.yaml?component';

export { ContractTermEditor, UcContractTerms };
